import { mobileImport } from 'AppRoutes'
import { saveProjectFileIds, saveProject } from 'actions/projectData/saveProject'
import {
  LEFT_MENU_WIDTH,
  MEDIA_ELEMENTS_SIZE,
  LOCAL_STORAGE_SOURCE_FILES_PARAMS,
  STORAGE_SOURCE_FILES_NAV_HISTORY,
  STORAGE_SOURCE_FILES_NAV_HISTORY_INDEX,
  newProjectId
} from 'constant'
import { SOURCE_FILE_TYPES } from 'enums'
import { isMediaFile, isSourceFile } from 'helpers/assets/fetchFile'
import { isEmpty, uniqBy } from 'lodash'
import { all, call, put, select, take, takeEvery } from 'redux-saga/effects'
import { selectSplitSize } from 'selectors/useInterface'
import * as API from '~/ServerAPI'
import * as ActionTypes from '~/actions/ActionTypes'
import { loadSourceFiles, updateSourceFile } from '~/actions/sourceFiles'
import { getSourceFilesByIds, getAssets, getSourceFiles, selectSourceFilesNavHistory,
  selectSourceFilesNavHistoryIndex, selectSourceFilesParams } from '~/selectors'

const saveGroupValueToStorage = (key, type, value) => {
  localStorage.setItem(key, JSON.stringify({
    ...JSON.parse(localStorage.getItem(key)),
    [type]: value,
  }))
}

function* handleLoadSourceFiles({ type: actionType, payload }) {
  const { type } = payload
  const sourceFilesParams = yield select(state => selectSourceFilesParams(state, type))
  const sourceFilesNavHistory = yield select(
    state => selectSourceFilesNavHistory(state, type)
  )
  const sourceFilesNavHistoryIndex = yield select(
    state => selectSourceFilesNavHistoryIndex(state, type)
  )

  const { media: mediaColumnSize } = yield select(selectSplitSize)

  // eslint-disable-next-line camelcase
  const { order, sort, filter, folder,
    currentAudioType = 'music', audioFilter = {}, category, source, search } = sourceFilesParams

  saveGroupValueToStorage(
    LOCAL_STORAGE_SOURCE_FILES_PARAMS,
    type,
    { order, sort, filter, folder, audioFilter, currentAudioType, category, source, search }
  )
  saveGroupValueToStorage(
    STORAGE_SOURCE_FILES_NAV_HISTORY,
    type,
    sourceFilesNavHistory
  )
  saveGroupValueToStorage(
    STORAGE_SOURCE_FILES_NAV_HISTORY_INDEX,
    type,
    sourceFilesNavHistoryIndex
  )

  const { width, height } = MEDIA_ELEMENTS_SIZE[type]
  const colElems = Math.floor((mediaColumnSize - LEFT_MENU_WIDTH) / width)
  const rowElems = Math.floor(window.innerHeight / height)
  const count = Math.max(rowElems * colElems, __CFG__.SOURCE_FILES_MANAGEMENT.LOADING_NUMBER)

  const currentPath = window.location.pathname
  if (currentPath.includes(mobileImport)) return

  if (type === SOURCE_FILE_TYPES.PROJECT_MEDIA) {
    return
  }
  if (type === SOURCE_FILE_TYPES.MEDIA || actionType === ActionTypes.SOURCE_FILES_SET_PARAMS) {
    yield put(loadSourceFiles(type, { force: true, count }))
  }
}

function* handleDeleteSourceFile({ payload }) {
  const { type } = payload

  const currentPath = window.location.pathname
  if (currentPath.includes(mobileImport)) return

  if (type !== SOURCE_FILE_TYPES.PROJECT_MEDIA) {
    const items = yield select(state => getSourceFiles(state, type))
    yield put(loadSourceFiles(type, { type, start: items.length, count: 1, force: true }))
  }
}

function* checkProjectFiles({ type }) {
  if ([
    ActionTypes.ASSET_ADDED_TO_TIMELINE,
    ActionTypes.TRANSITION_ADDED_TO_TIMELINE,
  ].includes(type)) {
    const { activeProjectId } = yield select(state => state.projectData)
    if (activeProjectId === newProjectId) {
      yield take(ActionTypes.PROJECTS_END_SAVING)
    }
    const allAssets = yield select(state => getAssets(state))
    const { activeProject } = yield select(state => state.projectData)

    if (activeProject && !isEmpty(allAssets)) {
      const { fileIds } = activeProject
      const newFileIds = allAssets.map(a => a.fileId).filter(id => !fileIds.includes(id))
      const sourceFiles = yield select(state => getSourceFilesByIds(state, newFileIds))
      const newProjectFileIds = Array.from(new Set(sourceFiles.map(sFile => sFile.id)))
      const newProjectMediaFiles = []

      for (const sFile of sourceFiles) {
        const { id, refCount } = sFile
        try {
          if (isMediaFile(sFile.id)) {
            yield call(API.updateReference, id, refCount ? 1 : 2)
          }
          if (isSourceFile(sFile.id)) {
            const { data } = yield call(API.getMediaFile, id)
            newProjectMediaFiles.push(data)
          }
        } catch (error) {
          console.error('Ошибка при обновлении файлов:', error)
        }
      }

      yield put(saveProjectFileIds(newProjectFileIds))

      if (!isEmpty(newProjectMediaFiles)) {
        yield put({
          type: ActionTypes.SOURCE_FILES_LOADED,
          payload: {
            type: SOURCE_FILE_TYPES.PROJECT_MEDIA,
            start: 1,
            items: uniqBy(newProjectMediaFiles, 'id'),
            totalCount: undefined,
          },
        })
        // update files in media (update refCount)
        for (const data of newProjectMediaFiles) {
          yield put(updateSourceFile(data))
        }
        yield put(saveProject())
      }
    }
  }
}

function* watchAll() {
  yield all([
    takeEvery([
      ActionTypes.SOURCE_FILES_SET_PARAMS,
      ActionTypes.ACTIONS_MEDIA_DIRECTORY_BACKWARD,
      ActionTypes.ACTIONS_MEDIA_DIRECTORY_FORWARD,
      ActionTypes.ACTIONS_MEDIA_DIRECTORY_OPEN,
    ], handleLoadSourceFiles),
    takeEvery([
      ActionTypes.SOURCE_FILE_DELETED,
      ActionTypes.SOURCE_FILES_MOVED ], handleDeleteSourceFile),
    takeEvery([
      ActionTypes.ASSET_ADDED_TO_TIMELINE,
      ActionTypes.TRANSITION_ADDED_TO_TIMELINE,
      ActionTypes.DELETE_TRANSITIONS,
      ActionTypes.DELETE_ASSETS,
    ], checkProjectFiles),
  ])
}

export default watchAll
